module.exports = __webpack_public_path__ + "static/media/b2.dadcddc8.png";